<ng-container *adaptLoading="!isInitialised">
    <adapt-collapsible-dashboard-element [name]="name"
                                         [isCollapsible]="false">
        @if (objectives?.length) {
            <div class="d-flex flex-column">
                @for (objective of objectives; track objective; let last = $last) {
                    <adapt-display-tree-objective class="tree-node-width"
                                                  [ngClass]="{ 'mb-2': !last }"
                                                  [objective]="objective"
                                                  [isCompactView]="true"></adapt-display-tree-objective>
                }
            </div>
        } @else {
            No {{ name?.toLowerCase() }} have been defined.
        }
    </adapt-collapsible-dashboard-element>
</ng-container>
